import React from 'react';

export default function FormField({ label, id, type = "text", required = false }) {
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-sm font-medium text-slate-200">
        {label}
      </label>
      <input 
        id={id} 
        name={id} 
        type={type} 
        required={required}
        className="w-full rounded-xl border bg-slate-900/60 px-3 py-2 text-slate-100 placeholder-slate-400" 
        placeholder={label} 
      />
    </div>
  );
}
